<template>
	<div class="wizard-steps mb-4">
		<div class="d-flex justify-content-between align-items-center">
			<!-- Step 1 -->
			<div class="step-item text-center flex-fill"
				:class="{ 'active': currentStep === 1, 'completed': currentStep > 1 }">
				<div class="step-circle mx-auto mb-2">
					<span v-if="currentStep > 1">✓</span>
					<span v-else>1</span>
				</div>
				<div class="step-label">
					<strong>{{ steps[0] }}</strong>
				</div>
			</div>

			<!-- Connector 1-2 -->
			<div class="step-connector flex-fill"></div>

			<!-- Step 2 -->
			<div class="step-item text-center flex-fill"
				:class="{ 'active': currentStep === 2, 'completed': currentStep > 2 }">
				<div class="step-circle mx-auto mb-2">
					<span v-if="currentStep > 2">✓</span>
					<span v-else>2</span>
				</div>
				<div class="step-label">
					<strong>{{ steps[1] }}</strong>
				</div>
			</div>

			<!-- Connector 2-3 -->
			<div class="step-connector flex-fill"></div>

			<!-- Step 3 -->
			<div class="step-item text-center flex-fill"
				:class="{ 'active': currentStep === 3, 'completed': currentStep > 3 }">
				<div class="step-circle mx-auto mb-2">
					<span>3</span>
				</div>
				<div class="step-label">
					<strong>{{ steps[2] }}</strong>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'WizardSteps',
	props: {
		currentStep: {
			type: Number,
			required: true,
		},
		steps: {
			type: Array,
			default: () => ['Konfigurasi', 'Mapping Produk', 'Ringkasan Order'],
		},
	},
};
</script>

<style scoped>
.wizard-steps {
	padding: 1rem 0;
	max-width: 800px;
	margin: 0 auto;
}

.step-item {
	position: relative;
}

.step-circle {
	width: 40px;
	height: 40px;
	border-radius: 50%;
	background-color: #e9ecef;
	color: #6c757d;
	display: flex;
	align-items: center;
	justify-content: center;
	font-weight: 600;
	font-size: 0.875rem;
	border: 2px solid #e9ecef;
}

.step-item.active .step-circle {
	background-color: #007bff;
	color: white;
	border-color: #007bff;
}

.step-item.completed .step-circle {
	background-color: #28a745;
	color: white;
	border-color: #28a745;
}

.step-label {
	font-size: 0.875rem;
	color: #6c757d;
}

.step-item.active .step-label {
	color: #007bff;
}

.step-item.completed .step-label {
	color: #28a745;
}

.step-connector {
	height: 2px;
	background-color: #e9ecef;
	position: relative;
	margin: 0 10px;
	align-self: center;
	margin-top: -25px;
}

.step-item.completed + .step-connector {
	background-color: #28a745;
}
</style>
